// Components
import { Button } from '@tracklib/kit'
import { Switch, Form } from 'components/form'

type EmailNotificationsFormProps = {
  onSubmit: (data: Record<string, unknown>) => Promise<Record<string, unknown>>
  isSubscribed: boolean
}

const EmailNotificationsForm = ({ onSubmit, isSubscribed }: EmailNotificationsFormProps): JSX.Element => (
  <Form onSubmit={onSubmit} initialValues={{ is_subscribed: isSubscribed }} enableReinitialize>
    {({ submitButtonProps }) => (
      <>
        <h2>Email notifications</h2>
        <div className="col">
          <Switch name="is_subscribed" label="News and updates" />
        </div>
        <footer>
          <Button {...submitButtonProps} datatesting="button_change_notifications">
            Save changes
          </Button>
        </footer>
      </>
    )}
  </Form>
)

export default EmailNotificationsForm
